import { render, staticRenderFns } from "./ProfilePlus.svg.vue?vue&type=template&id=6999e5bf"
import script from "./ProfilePlus.svg.vue?vue&type=script&lang=ts"
export * from "./ProfilePlus.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6999e5bf')) {
      api.createRecord('6999e5bf', component.options)
    } else {
      api.reload('6999e5bf', component.options)
    }
    module.hot.accept("./ProfilePlus.svg.vue?vue&type=template&id=6999e5bf", function () {
      api.rerender('6999e5bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/ProfilePlus.svg.vue"
export default component.exports